import dayjs from 'date'
import React from 'react'
import cx from 'classnames'
import { useModuleTitle } from 'models/settings'

import { HeaderButton } from 'components/inputs'

import NewCard from './components/NewCard/NewCard'
import useNews from './components/util/useNews'


const NewsBlock = (props) => {
  const { className } = props
  const { news, isFetching: isNewsFetching } = useNews()

  const { title } = useModuleTitle('NEWS')

  return (
    <div className={className}>
      <HeaderButton
        title={title}
        to="/news"
        size="h24"
      />
      {
        !isNewsFetching && news
          .map((post, index) => {
            const { id, image, teaser, title, created_at: date } = post

            return (
              <NewCard
                className={cx({ 'mt-32px': index, 'mt-24px': !index })}
                key={id}
                title={title.replace(/(<([^>]+)>)/gi, '') || teaser.replace(/(<([^>]+)>)/gi, '')}
                image={image}
                date={dayjs(date).format('D MMMM')}
                to={`/news/${id}`}
              />
            )
          })
      }
    </div>
  )
}

export default NewsBlock